import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from 'store/configureStore';
import { reportingOp } from 'store/ducks/Reportings';
import { TitleList } from 'store/ducks/globalTypes';
import { set_selectedDate } from 'store/ducks/Reportings/reportingSlice';
import { useHierarchicalTreePage } from 'utils/hooks/useHierarchicalTreePage';
import { buildRiskExposureTree } from './RiskExposureTreeBuilder';
import HierarchicalTreePage from '../HierarchicalTreePage';
import { useTranslation } from 'react-i18next';

const RiskExposureTree: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();
  const { date } = useSelector((state: RootState) => state.reportings);
  const { t } = useTranslation();
  const [selectedEntityId, setSelectedEntityId] = useState<number | null>(null);

  const { data, entityOptions } = useHierarchicalTreePage(
    reportingOp.getICTExposure,
    (res) => {
      const riskExposure = res?.risk_exposure ?? [];

      return riskExposure.flatMap((item: any) => {
        const base = {
          entity_name: item.entity_name,

          ict_system_name: item.ict_system_name,
          ict_risk_name: item.ict_risk_name,
          dependency_type_name: item.dependency_type_name,
          exposure_category_name: item.exposure_category_name,
          risk_exposure_name: item.risk_exposure_name,
        };

        const services = item.services ?? [];

        const serviceRows =
          services.length > 0
            ? services.map((s: any) => ({
                ...base,
                tpp_name: s.tpp_name,
                contract_name: s.contract_name,
                ict_service_name: s.ict_service_name,
              }))
            : [];

        const rootTppRow = {
          ...base,
          tpp_name: item.tpp_name,
          contract_name: item.contract_name,
          ict_service_name: item.ict_service_name,
        };

        return [...serviceRows, rootTppRow];
      });
    },

    selectedEntityId,
    date,
  );

  return (
    <HierarchicalTreePage
      title={t(TitleList.ICTRISKSTOTPP)}
      data={data}
      entityOptions={entityOptions}
      selectedEntityId={selectedEntityId}
      setSelectedEntityId={setSelectedEntityId}
      onDateChange={(dateString) => {
        dispatch(set_selectedDate(dateString));
      }}
      buildTree={buildRiskExposureTree}
    />
  );
};

export default RiskExposureTree;
